<template>
  <div class="number-grow-warp">
    <span ref="numberGrow" :data-time="time" class="number-grow bc-f-16rp bc-pd-lr-4rp bc-bd-radius-2 bc-mg-r-4rp" :data-value="value" v-for="i in strCollection">
      {{i}}
    </span>
  </div>
</template>

<script>
  export default {
    name: "w-number-grow",
    props:{
      time:{
        type:Number,
        default:2
      },
      value:{
        type:Number,
        default:""
      }
    },
    data(){
      return{
        strCollection:[]
      }
    },
    methods:{
      numberGrow(){
        let _this = this,
          step = (_this.value * 10) / (_this.time * 1000),
          current = 0,
          start = 0,
          timer = setInterval(function () {
          start += step;
          if(start > _this.value){
            clearInterval(timer);
            start = _this.value;
            timer = null;
          }
          if(current === start){
            return
          }
          current = start.toString();

          if(current.indexOf(".") != -1 ){
            let changeNum = parseInt(current.substring(0,current.indexOf('.')));
            current = changeNum.toString();
          }

          // ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1')
          _this.strCollection =  _this.converStr(current).split(",");
        },5)
      },
      //字符串转换成数组格式
      converStr(current){
        if(/\./.test(current)){
          return current.replace(/\d(?=(\d{1})+\.)/g, "$&,").split("").reverse().join("").replace(/\d(?=(\d{1})+\.)/g, "$&,").split("").reverse().join("");
        }else{
          return current.replace(/\d(?=(\d{1})+$)/g, "$&,");
        }
      },
    },

    mounted(){
      this.numberGrow(this.$refs.numberGrow);
    }
  }
</script>

<style scoped>
  /*.number-grow-warp{*/
    /*transform: translateZ(0);*/
  /*}*/
  .number-grow {
    color:#C25E26;
    display: inline-block;
    font-weight:bold;
    background:#DFF5FF;
  }

</style>